module.exports = __webpack_public_path__ + "img/LOADING_bsplogo_01_b08e1ea24.png";